// front/src/components/projects/ProjectTechStack.jsx
export default function ProjectTechStack({ techStack, tools }) {
  return (
    <div>
      {techStack && techStack.length > 0 && (
        <div className="mb-3">
          <h3 className="h6 mb-2">Tech stack</h3>
          <div className="d-flex flex-wrap gap-2">
            {techStack.map((t) => (
              <span key={t} className="badge bg-light text-dark border">
                {t}
              </span>
            ))}
          </div>
        </div>
      )}

      {tools && tools.length > 0 && (
        <div className="mb-3">
          <h3 className="h6 mb-2">Tools</h3>
          <div className="d-flex flex-wrap gap-2">
            {tools.map((t) => (
              <span key={t} className="badge bg-light text-dark border">
                {t}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
